import BrokenComponent from '../../common/components/BrokenComponent/BrokenComponent'
import { useTranslation } from 'react-i18next'

function Broken() {
  const { t } = useTranslation()

  return (
    <h1 className='center-message'>
      {t("Broken")}
      <BrokenComponent />
    </h1>
  )
}

export default Broken